import React from 'react';
import {
  f7,
  Page,
  Navbar,
  NavLeft,
  NavTitle,
  NavRight,
  Link,
  List,
  ListInput,
  Badge,
  Row,
  Col,
  Button,
  Block,
  BlockTitle,
  Toolbar,
  Icon,
  Sheet,
  PageContent,
  Popup,
  CardContent,
  Card,
  ListItem,
  CardFooter,
  CardHeader,
} from 'framework7-react';

import MapContainer from '../components/Map';

import { PrimaryLogo, ChefSvg } from '../components/crumbs';

import { connect } from 'react-redux';
import { compose } from 'redux';
import { LOAD_DISCOVER } from '../store/actions/discover';
import { withFirestore, firestoreConnect } from '../HOCs';
import { DocArray } from '../utils/_classes';
import { toast } from '../utils/_helpers';
import useGeoCode from '../utils/geoCode';

class Map extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      products: this.$f7.data.products,
      maps: null,
      service: null,
      results: null,
      deliveryAddress: '',
      instructions: '',
      disableButton: true,
      geolocation: '',
      pushNotification: true,

      // loacations
      homeLocation: {
        address: '',
      },
      workLocation: {
        address: '',
      },
    };
  }

  updateState(update) {
    const self = this;
    self.setState({
      ...self.state,
      ...update,
    });
  }

  // save last location
  saveLocation(lastLocation) {
    const self = this;

    // save location to DB if authenticated else save to local storage if un-authenticated
    if (self.props.auth.isLoaded && self.props.auth.isEmpty) {
      localStorage.setItem('lastLocation', JSON.stringify(lastLocation));
    }

    if (self.props.auth.isLoaded && !self.props.auth.isEmpty) {
      self.props.firestore
        .collection('users')
        .doc(self.props.auth.uid)
        .update({ lastLocation })
        .catch((error) => {});
    }
  }

  // Add autocomplete to input fields
  addAutocomplete(inputId, type) {
    const input = document.querySelector(`#${inputId} input`);
    const autocomplete = new window.google.maps.places.Autocomplete(input);
    // Set restriction to list of countries.
    autocomplete.setComponentRestrictions({
      country: ["ng"],
    });
    autocomplete.setFields(['formatted_address', 'geometry', 'name']);
    autocomplete.addListener('place_changed', () => {
      this.$f7.preloader.show();
      let response = autocomplete.getPlace();
      if (!response.geometry) {
        return toast(this.$f7.toast, {
          text: `No details available for input: ${response.name}. Please make sure you select a suggestted place`,
          position: 'bottom',
          horizontalPosition: 'center',
          closeButton: true,
          cssClass: 'custom-toast',
          closeTimeout: 4000,
        });
      }

      if (response) {
        const locationData = {
          address: response.name,
          geoLoc: {
            lat: response.geometry.location.lat(),
            lng: response.geometry.location.lng(),
          },
        };

        const update =
          type === 'home'
            ? { homeLocation: locationData }
            : { workLocation: locationData };

        this.props.firestore
          .collection('users')
          .doc(this.props.auth.uid)
          .update(update)
          .then(() => {
            this.saveLocation({
              deliveryAddress: response.name,
              geoLoc: {
                lat: response.geometry.location.lat(),
                lng: response.geometry.location.lng(),
              },
            });

            this.setState({
              ...this.state,
              deliveryAddress: response.name,
            });

            this.props.dispatch({
              type: LOAD_DISCOVER,
              payload: {
                deliveryAddress: response.name,
                geoLoc: {
                  lat: response.geometry.location.lat(),
                  lng: response.geometry.location.lng(),
                },
              },
            });
            this.$f7.preloader.hide();
            f7.popup.close('.map-input-popup');
          })
          .catch((error) => {
            this.$f7.preloader.hide();
            return toast(this.$f7.toast, {
              text: 'Something went wrong.',
              position: 'bottom',
              horizontalPosition: 'center',
              closeButton: true,
              cssClass: 'custom-toast',
              closeTimeout: 4000,
            });
          });
      }
    });
  }

  componentDidMount() {
    //play video background
    this.$f7.$('video').trigger('play');
  }

  loadCurrentLocation() {
    const self = this;

    // Load real time location
    navigator.geolocation.getCurrentPosition(
      (position) => {
        self.props.dispatch({
          type: LOAD_DISCOVER,
          payload: {
            geoLoc: {
              lat: position.coords.latitude,
              lng: position.coords.longitude,
            },
          },
        });

        useGeoCode(
          {
            type: 'Address',
            data: {
              lat: position.coords.latitude,
              lng: position.coords.longitude,
            },
          },
          (error, address) => {
            if (error) {
              self.setState({
                deliveryAddress: '',
                disableButton: false,
              });
              return self.props.dispatch({
                type: LOAD_DISCOVER,
                payload: {
                  deliveryAddress: '',
                },
              });
            }

            self.setState({
              deliveryAddress: address,
              disableButton: false,
            });

            self.props.dispatch({
              type: LOAD_DISCOVER,
              payload: {
                deliveryAddress: address,
              },
            });

            const lastLocation = {
              deliveryAddress: address,
              geoLoc: {
                lat: position.coords.latitude,
                lng: position.coords.longitude,
              },
            };

            self.saveLocation(lastLocation);
          }
        );
      },
      (error) => {
        const generalText = 'Please use the autocomplete on the input field';
        const text =
          error.code === 1
            ? `You have denied us access to your location. ${generalText}`
            : error.code === 2
            ? `An error occured while getting your geolocation. ${generalText}`
            : `Fetching location timed out. ${generalText}`;
        f7.dialog.alert(text, 'Location Error');
      },
      { maximumAge: 3000, timeout: 10000, enableHighAccuracy: true }
    );
  }

  render() {
    return (
      <Page name="map" onPageAfterIn={this.onPageAfterIn.bind(this)}>
        {/* Top Navbar */}
        <Navbar sliding={false}>
          <NavLeft>
            <Link iconF7="bars" panelOpen="left" />{' '}
          </NavLeft>
          <NavTitle sliding>
            {' '}
            <PrimaryLogo size="130" />{' '}
          </NavTitle>
          {/* Use unreadBell class to indicate new or unread notifications for user */}
          {this.props.auth && !this.props.auth.isEmpty ? (
            <NavRight>
              <Link
                iconOnly
                className={`${
                  this.$f7.methods.notificationBell().messages > 0
                    ? 'glow glow-4x'
                    : ''
                }`}
                onClick={() => {
                  this.$f7.methods.notificationBell('open');
                }}>
                <Icon ios="f7:bell" aurora="f7:bell" md="material:bell">
                  {this.$f7.methods.notificationBell().messages > 0 ? (
                    <Badge color="red">
                      {this.$f7.methods.notificationBell().messages}
                    </Badge>
                  ) : null}
                </Icon>
              </Link>
            </NavRight>
          ) : null}
        </Navbar>

        {/* Page content */}
        <div className="mapWrapper">
          <div
            id="gMapHere"
            className="business-map"
            style={{ width: '100%', height: '100%', position: 'relative' }}>
            {this.props.auth.isLoaded && this.props.profile.isLoaded ? (
              <MapContainer
                updateState={this.updateState.bind(this)}
                saveLocation={this.saveLocation.bind(this)}
                auth={this.props.auth}
                profile={this.props.profile}
              />
            ) : null}
          </div>
        </div>

        <div className="baseCard">
          <div className="paddingWrapper">
            <h2>Delivery Address</h2>
            <Row noGap>
              <Col
                width="85"
                style={{ cursor: 'pointer' }}
                onClick={() => {
                  f7.popup.open('.map-input-popup');

                  // Add autocomplete
                  if (
                    this.props.auth.isLoaded &&
                    !this.props.auth.isEmpty &&
                    this.props.profile.isLoaded &&
                    !this.props.profile.empty &&
                    !this.props.profile.homeLocation
                  ) {
                    this.addAutocomplete('homeLocation', 'home');
                  }

                  if (
                    this.props.auth.isLoaded &&
                    !this.props.auth.isEmpty &&
                    this.props.profile.isLoaded &&
                    !this.props.profile.empty &&
                    !this.props.profile.workLocation
                  ) {
                    this.addAutocomplete('workLocation', 'work');
                  }
                }}>
                <List className="inputList mapAddress">
                  <ListInput
                    type="text"
                    placeholder="Your delivery address"
                    value={this.state.deliveryAddress}>
                    <Icon
                      slot="media"
                      f7="map_pin_ellipse"
                      style={{ fontSize: '24px', marginTop: '5px' }}
                    />
                  </ListInput>
                </List>
              </Col>

              <Col width="15">
                <Button
                  round
                  fill
                  raised
                  className="button-fill-blue compass"
                  onClick={() => this.loadCurrentLocation()}>
                  <Icon f7="compass" />
                </Button>
              </Col>

              <Col width="100" style={{ marginTop: '20px' }}>
                <Button
                  round
                  fill
                  raised
                  disabled={this.state.deliveryAddress.trim() === ''}
                  onClick={() => {
                    window.history.pushState({}, document.title, '/');
                    f7.views.main.router.navigate('/discover/');
                  }}>
                  Deliver to this address
                </Button>
              </Col>
            </Row>
          </div>
        </div>

        <div className="blankDetailSVG">
          <ChefSvg size="300px" />
          <p>Enter delivery address to view contents arround you.</p>
        </div>

        {/* Popup map input field */}
        <Popup
          swipeToClose="to-bottom"
          className="map-input-popup"
          onPopupOpened={() => {
            f7.$('#inputLocationHere input').focus();
          }}>
          <Page>
            <Navbar>
              <NavLeft>
                <Link popupClose>Done</Link>
              </NavLeft>
              <NavTitle sliding>Enter Delivery Address</NavTitle>
            </Navbar>

            <Card style={{ width: '100%', margin: 0 }}>
              <CardContent style={{ paddingLeft: 0 }}>
                <List className="inputList">
                  <ListInput
                    clearButton
                    type="text"
                    placeholder="Type delivery address"
                    id="inputLocationHere"
                    value={this.state.deliveryAddress}
                    onBlur={(e) => {
                      if (e.target.value.trim() === '') {
                        this.setState({
                          ...this.state,
                          disableButton: true,
                        });
                        toast(this.$f7.toast, {
                          text: `Please enter a valid address`,
                          position: 'bottom',
                          horizontalPosition: 'center',
                          closeButton: true,
                          cssClass: 'custom-toast',
                          closeTimeout: 4000,
                        });
                      }
                    }}
                    onChange={(e) => {
                      const self = this;

                      if (e.target.value.trim() === '') {
                        self.setState({
                          ...self.state,
                          deliveryAddress: e.target.value,
                          results: [],
                        });
                      } else {
                        self.setState({
                          ...self.state,
                          deliveryAddress: e.target.value,
                        });

                        if (self.state.service) {
                          let request = {
                            query: e.target.value,
                            fields: ['formatted_address', 'geometry', 'name'],
                          };

                          self.state.service.findPlaceFromQuery(
                            request,
                            function (results, status) {
                              if (
                                status ===
                                google.maps.places.PlacesServiceStatus.OK
                              ) {
                                self.setState({
                                  ...self.state,
                                  results,
                                });
                              }
                            }
                          );
                        } else {
                          toast(self.$f7.toast, {
                            text: `Please check your network connection and reload the page.`,
                            position: 'bottom',
                            horizontalPosition: 'center',
                            closeButton: true,
                            cssClass: 'custom-toast',
                            closeTimeout: 4000,
                          });
                        }
                      }
                    }}>
                    <Icon
                      slot="media"
                      f7="map_pin_ellipse"
                      style={{ fontSize: '24px' }}
                    />
                  </ListInput>
                </List>
              </CardContent>
            </Card>

            {this.state.results && this.state.results.length > 0 ? (
              <Card style={{ width: '100%', marginLeft: 0, marginRight: 0 }}>
                <CardContent style={{ paddingLeft: 0 }}>
                  <List className="inputList" id="map-results">
                    {/* Load autocomplete place predictions here */}
                    {this.state.results.map(
                      ({ formatted_address, geometry, name }, i) => (
                        <ListItem
                          key={i}
                          onClick={() => {
                            // used for updating right panel location placeholder
                            f7.$('#locationFromMap').text(formatted_address);
                            this.setState({
                              ...this.state,
                              deliveryAddress: formatted_address,
                            });

                            this.props.dispatch({
                              type: LOAD_DISCOVER,
                              payload: {
                                deliveryAddress: formatted_address,
                                geoLoc: {
                                  lat: geometry.location.lat(),
                                  lng: geometry.location.lng(),
                                },
                              },
                            });

                            const lastLocation = {
                              deliveryAddress: formatted_address,
                              geoLoc: {
                                lat: geometry.location.lat(),
                                lng: geometry.location.lng(),
                              },
                            };

                            this.saveLocation(lastLocation);

                            f7.popup.close('.map-input-popup');
                          }}>
                          <Icon slot="media" f7="placemark_fill" />
                          <p slot="title" style={{ margin: 0 }}>
                            {name}
                          </p>
                          <small slot="title" style={{ margin: 0 }}>
                            {formatted_address}
                          </small>
                        </ListItem>
                      )
                    )}
                  </List>
                </CardContent>
              </Card>
            ) : this.props.auth.isLoaded &&
              !this.props.auth.isEmpty &&
              this.props.profile.isLoaded &&
              !this.props.profile.empty ? (
              <>
                <Card style={{ width: '100%', margin: 0, marginTop: "10pt" }}>
                  <CardContent style={{ paddingLeft: 0 }}>
                    <List className="inputList">
                      {!this.props.profile.homeLocation ? (
                        <ListInput
                          clearButton
                          type="text"
                          placeholder="Enter Home Location"
                          value={this.state.homeLocation.address}
                          id="homeLocation"
                          onChange={(e) => {
                            this.setState({
                              ...this.state,
                              homeLocation: {
                                ...homeLocation,
                                address: e.target.value,
                              },
                            });
                          }}>
                          <Icon
                            slot="media"
                            f7="house"
                            style={{ fontSize: '24px' }}
                          />
                        </ListInput>
                      ) : (
                        <ListItem
                          onClick={() => {
                            this.saveLocation({
                              deliveryAddress: this.props.profile.homeLocation
                                .address,
                              geoLoc: this.props.profile.homeLocation.geoLoc,
                            });

                            this.setState({
                              ...this.state,
                              deliveryAddress: this.props.profile.homeLocation
                                .address,
                            });

                            this.props.dispatch({
                              type: LOAD_DISCOVER,
                              payload: {
                                deliveryAddress: this.props.profile.homeLocation
                                  .address,
                                geoLoc: this.props.profile.homeLocation.geoLoc,
                              },
                            });
                            this.$f7.preloader.hide();
                            f7.popup.close('.map-input-popup');
                          }}
                          title={this.props.profile.homeLocation.address}
                          badge="Home"
                          badgeColor="blue">
                          <Icon
                            slot="media"
                            f7="house"
                            style={{ fontSize: '24px' }}
                          />
                        </ListItem>
                      )}
                      {!this.props.profile.workLocation ? (
                        <ListInput
                          clearButton
                          type="text"
                          placeholder="Enter Work Location"
                          value={this.state.workLocation.address}
                          id="workLocation"
                          onChange={(e) => {
                            this.setState({
                              ...this.state,
                              workLocation: {
                                ...workLocation,
                                address: e.target.value,
                              },
                            });
                          }}>
                          <Icon
                            slot="media"
                            f7="briefcase"
                            style={{ fontSize: '24px' }}
                          />
                        </ListInput>
                      ) : (
                        <ListItem
                          onClick={() => {
                            this.saveLocation({
                              deliveryAddress: this.props.profile.workLocation
                                .address,
                              geoLoc: this.props.profile.workLocation.geoLoc,
                            });

                            this.setState({
                              ...this.state,
                              deliveryAddress: this.props.profile.workLocation
                                .address,
                            });

                            this.props.dispatch({
                              type: LOAD_DISCOVER,
                              payload: {
                                deliveryAddress: this.props.profile.workLocation
                                  .address,
                                geoLoc: this.props.profile.workLocation.geoLoc,
                              },
                            });
                            this.$f7.preloader.hide();
                            f7.popup.close('.map-input-popup');
                          }}
                          title={this.props.profile.workLocation.address}
                          badge="Work"
                          badgeColor="orange">
                          <Icon
                            slot="media"
                            f7="briefcase"
                            style={{ fontSize: '24px' }}
                          />
                        </ListItem>
                      )}
                    </List>
                  </CardContent>
                </Card>
              </>
            ) : null}
          </Page>
        </Popup>
      </Page>
    );
  }

  //events
  onPageAfterIn() {
    let app = this.$f7;

    window.addEventListener('click', function () {
      app.$('video').trigger('play');
    });

    // check if url has merchant name
    let searchMerchant = window.location.search.split('=');
    if (searchMerchant.length > 1) f7.views.main.router.navigate('/discover/');
  }
}

const mapStateToProps = ({
  firebase: { auth, profile },
  discover,
  DB: {
    data,
    ordered,
    docs: { notification, loading },
  },
}) => ({
  auth,
  profile,
  discover,
  data,
  ordered,
  loadingDocs: loading,
  notifications: (notification && notification) || [],
});
const enhance = compose(
  withFirestore,
  firestoreConnect((props) => [
    // new Collections('products'),
    new DocArray('notification', `All,${props.auth.uid}`, 'to', props),
  ]),
  connect(mapStateToProps)
);

export default React.memo(enhance(Map));
